import {WebStorageStateStore} from 'oidc-client-ts';

// Origin used to build the OIDC redirect URIs. We prefer the browser's actual
// address-bar origin (window.location.origin) so the redirect scheme/host always
// matches how the SPA was loaded: http://localhost:8080 in dev and
// https://<public-host> in production (TLS terminated at the edge). Azure Entra
// only accepts https redirect URIs for non-localhost hosts, so following the
// real origin lets the SAME build/image work over both http (localhost) and
// https (production) without rebuilding. An explicit environmentSettings.websiteUrl
// still takes precedence for the rare case where the redirect host must differ
// from the serving host.
const appOrigin: string =
    environmentSettings.websiteUrl && environmentSettings.websiteUrl.trim() !== ''
        ? environmentSettings.websiteUrl
        : window.location.origin;

export const Settings = {
    authority: `${environmentSettings.authUrl}`,
    client_id: `${environmentSettings.clientId}`,
    redirect_uri: `${appOrigin}/login`,
    post_logout_redirect_uri: `${appOrigin}/logout?success=true`,
    // Authorization Code + PKCE. Azure "Single-page application" redirect URIs reject the legacy
    // implicit flow ('id_token token'), so we use the code flow which Azure SPA platform supports.
    response_type: 'code',
    response_mode: 'query' as const,
    scope: `openid profile email ${environmentSettings.apiScope}`,
    filterProtocolClaims: true,
    // The access token is scoped to our own API (audience = this app), not Microsoft Graph,
    // so calling the UserInfo endpoint with it returns 401 and breaks the redirect callback.
    // The id_token already provides email/name/preferred_username, so UserInfo is unnecessary.
    loadUserInfo: false,
    userStore: new WebStorageStateStore({ store: window.localStorage }),
    automaticSilentRenew: true,
    silent_redirect_uri: `${appOrigin}/SilentRenew`
};
